export interface IncomeReconciliationPageInput {
  limit?: number;
  nextToken?: string;
  fechaDesde?: string;
  fechaHasta?: string;
  banco?: string;
  estado?: string;
}

export interface IncomeReconciliationDebtor {
  id?: string | null;
  nombre?: string | null;
  tipo?: string | null;
}

export interface IncomeReconciliationAccountStatement {
  id?: string | null;
  clientId?: string | null;
  clientName?: string | null;
  period?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  dueDate?: string | null;
  createdAt?: string | null;
}

export interface IncomeReconciliationOrder {
  id?: string | null;
  estado?: string | null;
  numberOI?: string | null;
  tipoIngreso?: string | null;
  categoriaIngreso?: string | null;
  subcategoriaIngreso?: string | null;
  moneda?: string | null;
  monto?: number | null;
  montoPagado?: number | null;
  deudor?: IncomeReconciliationDebtor | null;
  accountStatement?: IncomeReconciliationAccountStatement | null;
}

export interface IncomeReconciliationRow {
  transactionId: string;
  banco?: string | null;
  fecha?: string | null;
  monto?: number | null;
  estado?: string | null;
  comision?: number | null;
  vinculoEncontrado: boolean;
  tipoOrden?: string | null;
  estadoVinculo?: string | null;
  deudorNombre?: string | null;
  deudorTipo?: string | null;
  numerosOI?: string[] | null;
  tiposIngreso?: string[] | null;
  monedaOI?: string | null;
  hasAccountStatement: boolean;
}

export interface IncomeReconciliationExpenseItem {
  id?: string | null;
  file?: string | null;
  fileExtend?: string | null;
  codigo?: string | null;
  monto?: number | null;
  observaciones?: string | null;
}

export interface IncomeReconciliationExpenseDetail {
  id?: string | null;
  fechaPago?: string | null;
  fechaReprogramacion?: string | null;
  estado?: string | null;
  tipoOrden?: string | null;
  egresos?: IncomeReconciliationExpenseItem[] | null;
  proveedor?: { nombreProveedor?: string | null } | null;
}

export interface IncomeReconciliationMovementDetail {
  id?: string | null;
  estado?: string | null;
  monto?: number | null;
  tipoCambio?: number | null;
  comision?: number | null;
  fechaEfectiva?: string | null;
  fechaReprogramacion?: string | null;
  cuentaCargo?: { nombre?: string | null; tipo?: string | null } | null;
  cuentaDestino?: { nombre?: string | null; tipo?: string | null } | null;
}

export interface IncomeReconciliationDetail {
  transactionId: string;
  tipoVinculo?: 'COBRANZA' | 'EGRESO' | 'MOVIMIENTO_INTRADAY' | null;
  vinculoEncontrado: boolean;
  cobranza?: {
    id?: string | null;
    estado?: string | null;
    fechaEfectiva?: string | null;
    listaOI?: IncomeReconciliationOrder[] | null;
  } | null;
  egreso?: IncomeReconciliationExpenseDetail | null;
  movimientoIntraday?: IncomeReconciliationMovementDetail | null;
}

export interface IncomeReconciliationPage {
  items: IncomeReconciliationRow[];
  nextToken: string | null;
  hasMore: boolean;
}

export interface IncomeReconciliationPageResponse {
  getConciliacionIngresosPage: IncomeReconciliationPage;
}

export interface IncomeReconciliationDetailResponse {
  getConciliacionIngresoDetalle: IncomeReconciliationDetail;
}

export interface IncomeReconciliationPendingInvoice {
  id?: string | null;
  numeroFile: string;
  numeroPI: string;
  descripcion: string;
  fechaOperacionFile: string;
  total: number;
  totalPagado: number;
  pendienteCobrar: number;
  cobradoSAF: number;
  montoCobrar: number;
}

export interface IncomeReconciliationPendingOrder {
  id?: string | null;
  numberOI?: string | null;
  accountStatement: IncomeReconciliationAccountStatement;
  listaPagosPendientes: IncomeReconciliationPendingInvoice[];
}

export interface IncomeReconciliationPendingCollections {
  transactionId: string;
  orders: IncomeReconciliationPendingOrder[];
}

export interface IncomeReconciliationPendingCollectionsResponse {
  getConciliacionIngresoCobrosPendientes: IncomeReconciliationPendingCollections;
}

export interface IncomeReconciliationProgress {
  items: IncomeReconciliationRow[];
  loadedPages: number;
  hasMore: boolean;
}

export type IncomeReconciliationOrderPaymentMode = 'PARTIAL' | 'COMPLETE';

export interface IncomeReconciliationOrderCandidatesInput {
  paymentMode: IncomeReconciliationOrderPaymentMode;
  currency: string;
  limit?: number;
  nextToken?: string;
}

export interface IncomeReconciliationOrderCandidate {
  id: string;
  montoPagado?: number | null;
  numberOI?: string | null;
  estado?: string | null;
  fechaRecepcion?: string | null;
  tipoIngreso?: string | null;
  categoriaIngreso?: string | null;
  subcategoriaIngreso?: string | null;
  moneda?: string | null;
  monto?: number | null;
  deudor?: IncomeReconciliationDebtor | null;
}

export interface IncomeReconciliationOrderCandidatesPage {
  items: IncomeReconciliationOrderCandidate[];
  nextToken: string | null;
  hasMore: boolean;
}

export interface IncomeReconciliationOrderCandidatesResponse {
  getIncomeReconciliationOrderCandidates: IncomeReconciliationOrderCandidatesPage;
}

export interface IncomeReconciliationOrderCandidatesProgress {
  items: IncomeReconciliationOrderCandidate[];
  loadedPages: number;
  hasMore: boolean;
}
